const wowApp = require('angular').module('wowApp.shop');

wowApp.value('panelOverride', { panel: '', isOpen: false });
wowApp.directive('wowOpenClosePanel', ['$timeout', '$state', 'ShopPageStateService', 'BreakpointsService', 'BrowserWindowService', 'AnimationsService', 'FeatureService', 'panelOverride', 'TrolleyService', 'AtmService', require('./openclosepanel-directives.js')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/openclosepanels/index.js
 **/